import React from 'react';
import { Select } from 'antd';
import { useQuery } from 'react-query';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';

import { getParDocumentByType, ParDocumentResponse } from 'services/Document';

const { Option } = Select;

export type DocSelectProps = SelectProps<any> & {
  doctype?: string;
  docmodule?: string;
  categorie?: string;
  isboth?: boolean;
  onSelected?: (criteria: ParDocumentResponse) => void;
  allowClear?: any
};

const DocCodeSelect = ({
  doctype,
  docmodule,
  categorie,
  isboth,
  value,
  onChange = noop,
  onSelected,
  allowClear,
}: DocSelectProps) => {
  const { data } = useQuery(['getParDocumentByType', { doctype, docmodule }], () =>
    getParDocumentByType({
      checkcategory: categorie ?? "",
      docmodule: docmodule ? docmodule : "",
      doctype: doctype ? doctype : "",
      objectid: 0,
      addboth: !isboth ? false : isboth
    }).then((res) => res.list || [])
  );
  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(data?.find((item) => item.doccode === value)!);
    }
  };

  return (
    <Select allowClear onChange={handleChange} value={value} style={{ width: '100%'}}>
      {data?.map((item, index) => (
        <Option key={index} value={item.doccode}>
          {item.doclabel}
        </Option>
      ))}
    </Select>
  );
};

export default DocCodeSelect;
